var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1413 19.0734C16.8515 19.3624 16.4988 19.5805 16.1107 19.7104L12.3817 20.9534C12.1129 21.0431 11.8314 21.0888 11.548 21.0887C10.8437 21.0887 10.1815 20.8144 9.6835 20.3164C8.9727 19.6054 8.72871 18.5716 9.04658 17.6181L10.2896 13.8893C10.4194 13.5012 10.6374 13.1484 10.9265 12.8586L18.9805 4.80469H3.22266C1.44568 4.80469 0 6.25037 0 8.02734V26.7773C0 28.5543 1.44568 30 3.22266 30H21.9727C23.7496 30 25.1953 28.5543 25.1953 26.7773V11.0195L17.1413 19.0734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1723 14.1017C12.0758 14.1981 12.0031 14.3157 11.96 14.4452L10.717 18.174C10.6654 18.3289 10.6579 18.495 10.6954 18.6539C10.7329 18.8127 10.8139 18.958 10.9293 19.0734C11.0447 19.1888 11.19 19.2698 11.3488 19.3073C11.5077 19.3448 11.6738 19.3373 11.8287 19.2857L15.5576 18.0428C15.687 17.9997 15.8046 17.927 15.9011 17.8305L26.8806 6.85103L23.1518 3.12218L12.1723 14.1017ZM27.9164 0.429038C27.3443 -0.143013 26.4169 -0.143013 25.8448 0.429038L24.3947 1.87917L28.1236 5.60808L29.5737 4.15794C30.1458 3.58589 30.1458 2.65841 29.5737 2.08636L27.9164 0.429038Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature32);
export default __webpack_public_path__ + "static/media/feature-3-2.98eceee856f9a83d4ff4f5c9e26f3edc.svg";
export { ForwardRef as ReactComponent };